import React, { useEffect, useState } from 'react'
import swal from 'sweetalert2';
import Select from 'react-select';
import { postCaddy } from '../api/caddyAPI';

const NextRoundModal = (props) => {

        const [selectedCaddy,        setSelectedCaddy]        = useState(null);
    

    useEffect(() => {
        $('#round-caddy-modal').modal({ backdrop: 'static' });

        $('#round-caddy-modal').on('hidden.bs.modal', function () {
            props.onDismissModal(); 
        });

        $('#round-caddy-modal').modal('toggle');
    }, [props.show]);

    const AddRoundHandler = async (e) => {
        e.preventDefault()
        var form = $('#add-round-form');
        form.validate({
            rules: {
                ddlCaddy: {
                    required: true
                }, 
            },
            messages: {
                ddlCaddy: {
                    required: "Please select caddy",
                },
            }
        });
        if (!form.valid()) return;

        try {
            await postCaddy(props.selectedDate, selectedCaddy.ID);
            props.fetchCaddyQueue()
            $("#round-caddy-modal").modal("hide");
        } catch (err) {
            swal.fire({
                icon                : 'error',
                titleText           : 'Error!',
                text                : err.message,
                buttonsStyling      : false,
                confirmButtonClass  : 'btn btn-brand',
            }); 
        }
    }

    return (
        <>
            <div className="modal fade" id="round-caddy-modal" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"> Add Caddy For Next Round </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"> </button>
                        </div>
                        <form id='add-round-form'>
                            <div className="modal-body">
                                <div className="modal-body padding-25 padding-b0">
                                    <div id="round-modal-holder" className="kt-form kt-form--label-right padding-10" role="form">
                                        <div className="form-group row">
                                            <label className="col-form-label col-lg-3">Caddy</label>
                                            <div className="col-xl-6 col-lg-6">
                                                <Select 
                                                    id="ddlCaddy" 
                                                    name="ddlCaddy"
                                                    className="multi-custom multi__control"
                                                    placeholder="Select Caddy"
                                                    value={selectedCaddy && {label: selectedCaddy.Name, value: selectedCaddy}}
                                                    onChange={(e) => setSelectedCaddy(e.value)}
                                                    options={props.caddyList.map(c => ({
                                                        label: `${c.Name}`,
                                                        value: c
                                                    }))}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer padding-tb10">
                                    <button type="button" data-dismiss="modal" className="btn btn-secondary margin-0 margin-r5 " id="btn_close">Close </button>
                                    <button type="button" className="btn btn-brand margin-0 " id="btnCaddySave" onClick={AddRoundHandler}>Add </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NextRoundModal